export default function UsuariosPage() {
  return (
    <div className="space-y-2">
      <h1 className="text-3xl font-semibold tracking-tight">Usuarios</h1>
      <p className="text-muted-foreground">
        Listado y gestión de usuarios del marketplace.
      </p>
    </div>
  );
}
